module.exports = __webpack_public_path__ + "static/media/divider-gray.fe9cf5e3.png";